<template>
  <ButtonDropdown
    flat
    color="standard"
    style="width: 200px"
    align="between"
    stretch
    :items="headerDropdownItems"
    class="button-dropdown"
  >
    <template v-slot:label>
      <ItemSection>
        <ItemLabel>{{ companyName }}</ItemLabel>
        <ItemLabel caption>{{ userName }}</ItemLabel>
      </ItemSection>
    </template>

    <template v-slot:footer>
      <div class="text-caption text-right q-px-md q-py-sm">
        {{ `${$t('Version')}: ${version}` }}
      </div>
    </template>
  </ButtonDropdown>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import { appEnv } from '@/lib/navigator';
import Config from '@/config';

import ButtonDropdown from '@design-system/components/ButtonDropdown.vue';
import ItemLabel from '@design-system/components/ItemLabel.vue';
import ItemSection from '@design-system/components/ItemSection.vue';

const messages = {
  en: {
    'Account info': 'Account info',
    Logout: 'Logout',
    Cancel: 'Cancel',
    'Are you sure you want to logout?': 'Are you sure you want to logout?',
  },
  ja: {
    'Account info': 'アカウント情報',
    Logout: 'ログアウト',
    Cancel: 'キャンセル',
    'Are you sure you want to logout?': 'ログアウトしてもよろしいですか？',
  },
};

export default {
  name: 'UserMenu',
  i18n: { messages },
  components: { ButtonDropdown, ItemSection, ItemLabel },
  data() {
    return {
      visible: false,
    };
  },
  computed: {
    ...mapState({
      subUserName: state => state.subUserName,
    }),

    ...mapState('user', {
      user: state => state.data,
    }),

    ...mapGetters('user', ['getUserName', 'getCompanyName']),

    userName() {
      return this.getUserName;
    },

    companyName() {
      return this.getCompanyName;
    },

    version() {
      return Config.version;
    },

    headerDropdownItems() {
      const items = [];

      // Dev Tools
      if (appEnv === 'localhost' || appEnv === 'dev') {
        items.push({
          key: 'devtools',
          label: this.$t('Dev Tools'),
          icon: 'construction',
          onClick: this.changeVisibleDevTools,
        });
      }

      // Logout
      items.push({
        key: 'logout',
        label: this.$t('Logout'),
        icon: 'exit_to_app',
        onClick: this.openLogoutConfirmation,
      });

      return items;
    },
  },
  methods: {
    ...mapActions('auth', ['logout']),

    ...mapActions('devTools', ['changeVisibleDevTools']),

    openLogoutConfirmation() {
      this.$confirm(this.$t('Are you sure you want to logout?'), this.$t('Logout'), {
        confirmButtonText: this.$t('Logout'),
        cancelButtonText: this.$t('Cancel'),
        type: 'warning',
      }).then(() => {
        this.logout();
      });
    },
  },
};
</script>
